<template>
  <div class="page-container">
        <!-- 背景图区域 -->
        <div class="page-wrapper" :style=" { backgroundImage:`url(${bgImg})`, height:'100vh', backgroundPosition:'50% 50%', backgroundColor:'#000' }">
            <div class="page-content">
                  <div class="text-container" style="top:36%; ">
                      <div style="margin-bottom:60px;"><img :src="bgLogo" /></div>
                      <div style="font-size:48px; letter-spacing:4px; line-height:42px; font-weight:lighter; color:#fff; margin-bottom:16px; ">能源 安防 环境 运维</div>
                      <div style="font-size:48px; letter-spacing:4px; line-height:48px; font-weight:bolder; color:#4D90FF; ">AI让工业更智能</div>
                      <div style="font-size:24px; letter-spacing:4px; line-height:42px; margin:36px 0; color:rgba(255, 255, 255, 0.6)">Energy Security Environment Maintenance<br/>AI makes industry smarter</div>
                      <el-button size="large" color="" class="custom-btn-blue"  @click="handleClick">立即试用</el-button>
                  </div>
            </div>
        </div>
      
        <!-- 二级介绍展开区 -->
        <HoverUnfold />
        <!-- 子应用轮播展示区 -->
        <FollowSlider />
        <!-- 小易AI内容区----场景化定制 -->
        <AIContent1 />
        <!-- 小易AI内容区----千人千面 -->
        <AIContent2 />  
        <!-- 精选案例轮播 -->
        <CaseContent />
        <!-- 客户案例 -->
        <AllCustomerCase />
          <!-- 华翊动态 -->
        <LatestNews />
        <!-- 底部背景 -->
          <div class="page-wrapper" :style="{ position:'relative', height:'240px', overflow:'hidden' }">
              <img :src="Bg" class="motion-bg" />  
              <div class="page-content" style="display:flex; align-items: center; flex-direction:column; justify-content:center; ">
                    <div style="font-size:24px; line-height:42px; margin:26px 0; color:#fff; ">能源 安防 环境 运维 智慧工业集成商</div>
                    <div><el-button class="custom-btn-white" size="large" style="color:" @click="handleClick">立即试用</el-button></div>
                </div>
          </div>
  </div>
</template>

<script>
  import { markAction } from '@/api/global.js';
  import bgImg from '@/assets/home-bg.jpg';
  import bgLogo from '@/assets/home-bg-logo.png';
  import HoverUnfold from './HoverUnfold.vue';
  import AIContent1 from './AIContent1.vue';
  import AIContent2 from './AIContent2.vue';
  import FollowSlider from '@/components/FollowSlider/index.vue';
  import CaseContent from './CaseContent.vue';
  import AllCustomerCase from './AllCustomerCase.vue';
  import LatestNews from './LatestNews.vue';
  import Bg from '@/assets/motion-bg.png';
  
  export default {
      data(){
        return {
          bgImg,
          bgLogo,
          Bg
        }
      },
      methods:{
          handleClick(){
            markAction({ operationType:'进入厂务' });
            window.open('http://iot.ifmcs.com', '__blank');
          }
      },
      components:{
        HoverUnfold,
        FollowSlider,
        AIContent1,
        AIContent2,
        CaseContent,
        AllCustomerCase,
        LatestNews
      },
      watch:{
        '$route.query.pos':{
          immediate:true,
          handler:function(newVal){
              if ( this.$route.query.pos ) {
                  let ele = document.getElementsByClassName('ps')[0];
                  if ( ele ) {
                    ele.scrollTop = window.innerHeight + Number(this.$route.query.pos)
                  }
              }
          }
        }
      }
  }

</script>

<style>
  .motion-bg {
      position:absolute;
      width:100%;
      top:0;
      animation: float 40s ease-out infinite;
  }
  @keyframes float {
      0%{
          transform:translateY(0);
      }
      /* 25% {
          transform:translate(-80%, -50%);
      } */
      50%{
          transform:translateY(-400px);
      }
      
      100%{
          transform:translateY(0);
      }
  }
</style>

